import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { $current, QueryParam, withScope } from '@bingads-webui-react/scope-service';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { withServerContext } from '@bingads-webui-campaign-react/server-context';
import { withInstrumentation } from '@bingads-webui-react/hoc-with-instrumentation';
import {
  withImportSiteMap,
  processorSet,
} from '@bingads-webui-campaign-react/with-site-map';

import { StyledImportCenterMainMenuView } from './import-center-main-menu-view';

const modePreferenceName = 'WebApp.CampaignUI.New.ImportCenterManiMenuMode';

const defaultRoute = {
  Google: '/campaign/vnext/importcenter/google/import',
  Facebook: '/campaign/vnext/importcenter/facebook/import',
  Amazon: '/campaign/vnext/importcenter/amazon/import',
  Pinterest: '/campaign/vnext/importcenter/pinterest/import',
};

const updateUrlOnConnectionClick = (node, scope) => {
  // TODO: set import type unselected
  const connectionId = scope.values.connectionId ? scope.values.connectionId : null;
  if (connectionId !== node.Id) {
    scope.set({
      cid: $current,
      ...scope.values.aid ? { aid: $current } : {},
      uid: $current,
      connectionId: node.Id,
    });
  } else {
    return;
  }
  scope.save(defaultRoute[node.Type]);
};

const updateUrlOnImportTypeClick = (node, scope) => {
  const connectionId = scope.values.connectionId ? scope.values.connectionId : null;
  if (connectionId) {
    scope.remove('connectionId');
  }
  scope.save(node.routePrefix + node.route);
};
class ImportCenterMainMenuAdapter extends React.PureComponent {
  constructor(props) {
    super(props);

    this.mainMenuScenario = props.instrumentation.createScenarioAndActivity({
      scenarioName: 'importCenterMainMenuScenario',
      activityName: 'toggleMainMenuActivity',
    }).scenario;
  }

  // click top import item will route
  onImportTypeItemClick = (node) => {
    const { scope } = this.props;
    updateUrlOnImportTypeClick(node, scope);
  };

  // click connection item will add connectionId in url
  onConnectionItemClick = (node) => {
    const { scope } = this.props;
    updateUrlOnConnectionClick(node, scope);
  };

  render() {
    return (
      <React.Fragment>
        <StyledImportCenterMainMenuView
          {...this.props}
          onImportTypeItemClick={this.onImportTypeItemClick}
          onConnectionItemClick={this.onConnectionItemClick}
          modePreferenceName={modePreferenceName}
          mainMenuScenario={this.mainMenuScenario}
        />
      </React.Fragment>
    );
  }
}

ImportCenterMainMenuAdapter.propTypes = {
  scope: PropTypes.instanceOf(QueryParam).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  instrumentation: PropTypes.shape({
    createScenarioAndActivity: PropTypes.func,
  }).isRequired,
  siteMap: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]).isRequired,
};

export const ImportCenterMainMenu = _.compose(
  withI18nConsumer,
  withServerContext,
  withScope,
  withInstrumentation,
  TempComponent => withImportSiteMap(TempComponent, processorSet.all, 'import-center/import-center/*')
)(ImportCenterMainMenuAdapter);
